export default __webpack_public_path__ + "/static/media/jobhunter-common-web/icon_emoji.7e4ea85c623b8dc77116ab54be74d74e.svg";